module.exports = __webpack_public_path__ + "static/main-f5b3427d79127dc6eebac7e2800a3dbd.png";